import {trigger, animate, style, group, query, transition} from "@angular/animations";

export const projectListAnimation = trigger("routeAnimations", [
	// transition('* => *', [
	//   query(':enter, :leave', style({ position: 'fixed', width: '100%' })
	//     , { optional: true }),
	//   group([
	//     query(':enter', [
	//       style({ transform: 'translateX(-100%)' }),
	//       animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' }))
	//     ], { optional: true }),
	//     query(':leave', [
	//       style({ transform: 'translateX(0%)' }),
	//       animate('0.5s ease-in-out', style({ transform: 'translateX(100%)' }))
	//     ], { optional: true }),
	//   ])
	// ]),
	transition("project-list => project-edit", [
		group([
			query(":enter, :leave", style({position: "fixed", width: "100%"}), {optional: true}),
			query(
				":enter",
				[style({transform: "translateX(100%)"}), animate("0.5s ease-in-out", style({transform: "translateX(0%)"}))],
				{optional: true},
			),
			query(
				":leave",
				[style({transform: "translateX(0%)"}), animate("0.5s ease-in-out", style({transform: "translateX(-100%)"}))],
				{optional: true},
			),
		]),
	]),
]);
